<ui-dialog
    size="small"
    [open]="showTimeOffHoursPayrollModal"
    (closing)="closeTimeOffHoursPayrollModal()"
    header="{{ 'time-off-v3.removeOrKeepTimeOffHoursInPayroll' | translate }}"
>
    <p [innerHTML]="'time-off-v3.removeOrKeepHoursPayrollMessage' | translate: { date: currentPayrollStartDate }"></p>

    <p>{{ 'time-off-v3.howWouldYouLikeToContinue' | translate }}</p>

    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeTimeOffHoursPayrollModal()">{{
            'time-off-v3.close' | translate
        }}</ui-button>
        <ui-button type="primary" (click)="removeTimeOffHoursFromPayroll()">{{
            'time-off-v3.removeHoursFromPayrollAndSave' | translate
        }}</ui-button>
        <ui-button type="primary" (click)="keepTimeOffHoursInPayroll()">{{
            'time-off-v3.keepHoursInPayrollAndSave' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>
<ui-dialog
    size="small"
    [open]="showAcceptingHoursInPayrollModal"
    (closing)="closeTimeOffHoursPayrollModal()"
    (primaryButtonPressed)="confirmShowAcceptingHoursInPayroll()"
    [primaryButtonLabel]="'time-off-v3.confirm' | translate"
    (secondaryButtonPressed)="closeShowAcceptingHoursInPayrollModal()"
    [secondaryButtonLabel]="'time-off-v3.cancel' | translate"
    header="{{ 'time-off-v3.confirmTheStartDateForAcceptingHoursInPayroll' | translate }}"
>
    <p
        [innerHTML]="
            'time-off-v3.confirmTheStartDateForAcceptingHoursInPayrollMessage'
                | translate: { date: currentPayrollStartDate }
        "
    ></p>

    <p>{{ 'time-off-v3.howWouldYouLikeToContinue' | translate }}</p>
</ui-dialog>
<ui-dialog
    size="small"
    [open]="showPayrollIntegrationCannotBeChangedModal"
    (closing)="closePendingHoursInPayrollModal()"
    (primaryButtonPressed)="closePendingHoursInPayrollModal()"
    [primaryButtonLabel]="'time-off-v3.close' | translate"
    header="{{ 'time-off-v3.confirmTheStartDateForAcceptingHoursInPayroll' | translate }}"
>
    <p [innerHTML]="'time-off-v3.pendingHoursWaitingApproval' | translate"></p>

    <p>{{ 'time-off-v3.ensurePendingHoursResolved' | translate }}</p>
</ui-dialog>
<div class="ui basic segment max-width" [class.loading]="isLoading">
    <app-header [back]="true" title="{{ 'time-off-v3.editTimeOffType' | translate }}"></app-header>

    <app-time-off-types-form #timeOffTypesForm [timeOffType]="timeOffType" [isUpdate]="true"></app-time-off-types-form>

    <div class="buttons">
        <ui-button type="outline" (click)="onCancel()">{{ 'time-off-v3.cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSaveWithModal()">{{ 'time-off-v3.save' | translate }}</ui-button>
    </div>
</div>
